import { CommonModule } from '@angular/common';
import { Component, inject, OnInit } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { AppStore } from '@projects/adir/src/app/app.store';
import { Image } from '@shared/src/lib/components/image/image.interface';
import { DropdownComponentOption } from '@shared/src/lib/components/filter/filter.interface';
import { AuthService } from '@shared/src/services/auth/auth.service';

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [CommonModule, RouterOutlet],
  templateUrl: './app.component.html',
  styleUrl: './app.component.css',
})
export class AppComponent implements OnInit {
  protected readonly store = inject(AppStore);
  title = 'ADIR';
  isSelected = false;

  onCheckedChange(checked: boolean): void {
    this.isSelected = checked;
  }

  imageNames = Object.values(Image.Names);

  constructor(private readonly authService: AuthService) {}

  ngOnInit(): void {
    this.authService.login();
  }

  handleButtonClicked() {
    alert('Button clicked');
  }

  onOptionsSelected(selected: DropdownComponentOption[]) {
    console.log('Selected options:', selected);
  }
}
